import produce from 'immer';

// Action Types
import { LOGOUT } from '../../constants/actionTypes';
export const RESTORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS = 'RESTORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS';
export const READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS = 'READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS';
export const STORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS = 'STORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS';

// States
const initState = [];

// Action Creators
export function readExpireSoonPackageSubscriptions() {
  return {
    type: READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
  };
}

// Reducer
export default produce((draft, action) => {
  switch (action.type) {
    case RESTORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS:
    case STORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS: {
      return action.payload;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
